
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./app/App.tsx";
import "./styles/index.css";
import "./app/styles/animations.css";

// Configure ReactQuery client with Supabase optimizations
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds default stale time
      gcTime: 1000 * 60 * 5, // 5 minutes garbage collection (renamed from cacheTime)
      retry: (failureCount, error: any) => {
        // Don't retry on auth errors
        if (error?.status === 401) return false;
        // Retry up to 2 times for other errors
        return failureCount < 2;
      },
    },
  },
});

// Expose supabase to browser console for dev tools and scripts
if (process.env.NODE_ENV === 'development') {
  import('./lib/supabase').then(({ supabase }) => {
    (window as any).supabase = supabase;
  });
  (window as any).queryClient = queryClient;
}

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = createRoot(container);
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);